import type {IPrimaryAccessPreview} from '@api/contracts/state.types'

import css from './ui.primary-access-preview.module.scss'


interface IPrimaryAccessPreviewProps {
    preview: IPrimaryAccessPreview
}

const normalizeCourseName = (value: string) => value.trim().replace(/\s+/g, ' ').toLocaleLowerCase('ru-RU')

export const PrimaryAccessPreview = ({preview}: IPrimaryAccessPreviewProps) => {
    const listenerCount = preview.programs.reduce((count, program) => count + program.listenerCount, 0)

    return <div className={css.preview}>
        <div className={css.summary}>
            <span>Учебная платформа</span>
            <strong>{preview.siteName}</strong>
            <span>{listenerCount} чел. получат доступ по указанным ниже привязкам</span>
        </div>

        <div className={css.list}>
            {preview.programs.map((program, index) => {
                const hasDifference = normalizeCourseName(program.crmCourseName) !== normalizeCourseName(program.siteCourseName)
                    || program.crmVolumeHours !== program.siteVolumeHours

                return <section className={css.program} key={program.contractProgramID} aria-label={`Сопоставление программы ${index + 1}`}>
                    <div className={css.programHeader}>
                        <div>
                            <span>Программа {index + 1}</span>
                            <strong>{program.listenerCount} чел.</strong>
                        </div>
                        <span className={hasDifference ? css.difference : css.match}>
                            {hasDifference ? 'Есть расхождение' : 'Данные совпадают'}
                        </span>
                    </div>

                    <div className={css.comparison}>
                        <div className={css.source}>
                            <span className={css.sourceLabel}>Сохранено в CRM</span>
                            <strong className={css.courseName}>{program.crmCourseName || 'Название не указано'}</strong>
                            <span className={css.hours}>{program.crmVolumeHours} ак. ч.</span>
                        </div>

                        <span className={css.arrow} aria-hidden='true'>→</span>

                        <div className={css.source}>
                            <span className={css.sourceLabel}>Фактический курс {preview.siteName}</span>
                            <strong className={css.courseName}>{program.siteCourseName}</strong>
                            <span className={css.hours}>{program.siteVolumeHours} ак. ч.</span>
                        </div>
                    </div>

                    <div className={css.identifiers}>
                        <span>course_program_id: <strong>{program.courseProgramID}</strong></span>
                        <span>LMS course_id: <strong>{program.lmsCourseID}</strong></span>
                    </div>
                </section>
            })}
        </div>

        <p className={css.notice}>Доступ будет предоставлен к фактическому курсу справа.</p>
    </div>
}